var exports = {
  "p": "InProgressCommentIndicatorBackground__nD9Slv",
  "e": "InProgressCommentIndicatorContainer__DWfExY",
};

module.exports = exports;
